<!-- <section class="flex-fill">
  <div class="px-sm-0 px-0 mt-2 h-100 pb-2" >
    <div class="mx-3 sidebar px-2 " style="height: 100% !important;" [ngClass]="heightClass">
      <div class="d-flex flex-column align-items-center align-items-sm-start px-0 pt-3 text-white">
        <ul class="d-flex flex-column align-items-center align-items-sm-start px-2 pt-3 text-white" style="gap: 30px;" id="menu"
        [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
          <div class="nav-item-wrapper" [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
            <li class="nav-item ps-2" routerLink="/tours" routerLinkActive="active">
              <a (click)="GotoTourDashboard()" class="nav-link align-middle sidebar_background"
              [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
                <svg width="24" height="24" class="icon-color" style="vertical-align: -7px;" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13 12C13 11.4477 13.4477 11 14 11H19C19.5523 11 20 11.4477 20 12V19C20 19.5523 19.5523 20 19 20H14C13.4477 20 13 19.5523 13 19V12Z"
                  stroke="#141C24" stroke-width="1.5" stroke-linecap="round"/>
                <path
                  d="M4 5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5V12C10 12.5523 9.55228 13 9 13H5C4.44772 13 4 12.5523 4 12V5Z"
                  stroke="#141C24" stroke-width="1.5" stroke-linecap="round" />
                <path
                  d="M4 17C4 16.4477 4.44772 16 5 16H9C9.55228 16 10 16.4477 10 17V19C10 19.5523 9.55228 20 9 20H5C4.44772 20 4 19.5523 4 19V17Z"
                  stroke="#141C24" stroke-width="1.5" stroke-linecap="round" />
                <path
                  d="M13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H14C13.4477 8 13 7.55228 13 7V5Z"
                  stroke="#141C24" stroke-width="1.5" stroke-linecap="round" />
              </svg>
                <span class="ms-2 d-sm-inline sidenavbar_list pt-2" style="font-weight: 650;" [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">{{ 'Dashboard' | translate }}</span>
              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item ps-2" routerLink="/schedule-a-tour" routerLinkActive="active">
              <a (click)="GotoSchedule_a_tour()" class="nav-link align-middle sidebar_background"
              [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
                <svg width="25" height="25" class="icon-color" style="vertical-align: -6px;" viewBox="0 0 25 25" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 20.0001V16.0001C10 15.4478 10.4477 15.0001 11 15.0001H13C13.5523 15.0001 14 15.4478 14 16.0001V20.0001M11.3356 4.5906L5.67127 9.62559C5.2443 10.0051 5 10.5491 5 11.1204V18.0001C5 19.1046 5.89543 20.0001 7 20.0001H17C18.1046 20.0001 19 19.1046 19 18.0001V11.1204C19 10.5491 18.7557 10.0051 18.3287 9.62559L12.6644 4.5906C12.2855 4.25382 11.7145 4.25382 11.3356 4.5906Z"
                    stroke="#141C24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="ms-2 d-sm-inline sidenavbar_list pt-2" style="font-weight: 650;" [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">{{ 'BookTour' | translate }}</span>
              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item ps-2" routerLink="/my-tours" routerLinkActive="active">
              <a (click)="GotoMy_tours()" class="nav-link align-middle sidebar_background" style="padding-top: 4px !important;"
              [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
                <svg width="22" height="22" class="icon-color" style="vertical-align: -6px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                  d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10M20 10V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V10M20 10H4M8 3V7M16 3V7"
                  stroke="#141C24" stroke-width="1.5" stroke-linecap="round" />                </svg>
                  <span class="d-sm-inline sidenavbar_list" style="font-weight: 650;margin-left: 10px;"
                  [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">{{ 'MyTours' | translate }}</span>              </a>
            </li>
          </div>
          <div class="nav-item-wrapper">
            <li class="nav-item ps-2" routerLink="/Feedback-view" routerLinkActive="active">
              <a (click)="Goto_feedback()" class="nav-link align-middle sidebar_background" style="padding-top: 4px !important;"
              [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
                <svg width="22" height="22" class="icon-color" style="vertical-align: -6px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                  d="M3 7C3 5.34315 4.34315 4 6 4H18C19.6569 4 21 5.34315 21 7V14C21 15.6569 19.6569 17 18 17H11.1161C11.0443 17 10.978 17.0385 10.9424 17.1008L9.38728 19.8223C9.20635 20.1389 8.75826 20.1616 8.54629 19.8648L6.55982 17.0838C6.52228 17.0312 6.46167 17 6.39708 17H6C4.34315 17 3 15.6569 3 14V7Z"
                  stroke="#141C24" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span class="ms-2 d-sm-inline sidenavbar_list" style="font-weight: 650;" [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">{{ 'Feedback' | translate }}</span>
              </a>
            </li>
          </div>
        </ul>
        <hr>
      </div>
    </div>
  </div>
</section> -->


<section class="flex-fill">
  <div class="px-sm-0 px-0 mt-2 h-100 pb-2">
    <div class="sidebar" [ngClass]="heightClass">
      <ul class="sidebar-nav pt-2" id="menu"
        [ngClass]="{'english': currentLanguage === 'en', 'portuguese': currentLanguage === 'pt'}">
        <li class="nav-item px-2" routerLink="/tours" queryParamsHandling="preserve" routerLinkActive="active">
          <a (click)="GotoTourDashboard()" class="nav-link active">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M13.5 12C13.5 11.4477 13.9477 11 14.5 11H19.5C20.0523 11 20.5 11.4477 20.5 12V19C20.5 19.5523 20.0523 20 19.5 20H14.5C13.9477 20 13.5 19.5523 13.5 19V12Z"
                stroke="#1f549f" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M4.5 5C4.5 4.44772 4.94772 4 5.5 4H9.5C10.0523 4 10.5 4.44772 10.5 5V12C10.5 12.5523 10.0523 13 9.5 13H5.5C4.94772 13 4.5 12.5523 4.5 12V5Z"
                stroke="#1f549f" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M4.5 17C4.5 16.4477 4.94772 16 5.5 16H9.5C10.0523 16 10.5 16.4477 10.5 17V19C10.5 19.5523 10.0523 20 9.5 20H5.5C4.94772 20 4.5 19.5523 4.5 19V17Z"
                stroke="#1f549f" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M13.5 5C13.5 4.44772 13.9477 4 14.5 4H19.5C20.0523 4 20.5 4.44772 20.5 5V7C20.5 7.55228 20.0523 8 19.5 8H14.5C13.9477 8 13.5 7.55228 13.5 7V5Z"
                stroke="#1f549f" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <span class="ms-1">{{ 'Dashboard' | translate }}</span>
          </a>
        </li>
        <li class="nav-item px-2" routerLink="/schedule-a-tour" queryParamsHandling="preserve" routerLinkActive="active">
          <a (click)="GotoSchedule_a_tour()" class="nav-link">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 20.0001V16.0001C10 15.4478 10.4477 15.0001 11 15.0001H13C13.5523 15.0001 14 15.4478 14 16.0001V20.0001M11.3356 4.5906L5.67127 9.62559C5.2443 10.0051 5 10.5491 5 11.1204V18.0001C5 19.1046 5.89543 20.0001 7 20.0001H17C18.1046 20.0001 19 19.1046 19 18.0001V11.1204C19 10.5491 18.7557 10.0051 18.3287 9.62559L12.6644 4.5906C12.2855 4.25382 11.7145 4.25382 11.3356 4.5906Z"
                stroke="#1f549f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="ms-1">{{ 'BookTour' | translate }}</span>
          </a>
        </li>
        <li class="nav-item px-2" routerLink="/my-tours" queryParamsHandling="preserve" routerLinkActive="active">
          <a (click)="GotoMy_tours()" class="nav-link">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10M20 10V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V10M20 10H4M8 3V7M16 3V7"
                stroke="#1f549f" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <span class="ms-1">{{ 'MyTours' | translate }}</span>
          </a>
        </li>
        <li class="nav-item px-2" routerLink="/Feedback-view" queryParamsHandling="preserve" routerLinkActive="active">
          <a (click)="Goto_feedback()" class="nav-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M3.5 7C3.5 5.34315 4.84315 4 6.5 4H18.5C20.1569 4 21.5 5.34315 21.5 7V14C21.5 15.6569 20.1569 17 18.5 17H11.6161C11.5443 17 11.478 17.0385 11.4424 17.1008L9.88728 19.8223C9.70635 20.1389 9.25826 20.1616 9.04629 19.8648L7.05982 17.0838C7.02228 17.0312 6.96167 17 6.89708 17H6.5C4.84315 17 3.5 15.6569 3.5 14V7Z"
                stroke="#1f549f" stroke-width="1.5" />
            </svg>
            <span class="ms-1">{{ 'Feedback' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</section>

